module.exports = __webpack_public_path__ + "img/icon-facebook-circle.abdd0cad.svg";